<template>
    <div class="tm-rangliste-wrapper">

      <div v-if="loading" class="tm-state">
        <span class="tm-state__spinner"></span> Lade Rangliste...
      </div>

      <div v-else-if="error" class="tm-state tm-state--column tm-state--error">
        {{ error }}
        <button type="button" class="tm-retry-btn" @click="ladenPerRest">Erneut versuchen</button>
      </div>

      <div v-else-if="keineDatenVorhanden" class="tm-state">
        Noch keine Rangliste für diese Runde verfügbar.
      </div>

      <template v-else>

        <div class="tm-ranking-header">
          <div v-if="live" class="tm-rangliste-live-badge">
            <span class="tm-live-dot"></span> Live
          </div>

          <div v-if="standText || rundeAbgeschlossen" :class="['tm-stand', { 'tm-stand--alt': veraltet && !rundeAbgeschlossen }]">
            <span class="tm-stand__punkt hidden"></span>
            <template v-if="rundeAbgeschlossen">
              Runde finalisiert<template v-if="rundeStand"> · {{ new Date(rundeStand).toLocaleString('de-AT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) }}</template>
            </template>
            <template v-else-if="verbunden">{{ live ? 'Live' : 'Aktualisiert' }} · Stand {{ standText }}</template>
            <template v-else>Verbindung getrennt · Stand {{ standText }}</template>
          </div>

        </div>

        <div v-if="isLive && tickerAnzeige.length" class="tm-ticker" v-auto-animate="{ duration: 300 }">
          <div v-for="t in tickerAnzeige" :key="t.id" class="tm-ticker__eintrag">
            <span class="tm-ticker__ball">⚽</span>
            <div v-if="t" class="tm-ticker__spiel">
              <div class="tm-ticker__spiel_team" :class="{ 'tm-ticker__spiel_team--tor': t.heimTor }"><div class="tm-ticker__spiel_tor">{{ t.heimtore }}</div><div>{{ t.heim }}</div></div>
              <div class="tm-ticker__spiel_team" :class="{ 'tm-ticker__spiel_team--tor': t.auswTor }"><div class="tm-ticker__spiel_tor">{{ t.austore }}</div><div>{{ t.auswaerts }}</div></div>
            </div>
            <div v-if="zeige.tickerPlatz && tp(t)?.neu != null" class="tm-ticker__platz"
                    :class="{ 'is-up': tp(t).neu < tp(t).alt, 'is-down': tp(t).neu > tp(t).alt }">
                {{ tp(t).neu < tp(t).alt ? '▲' : tp(t).neu > tp(t).alt ? '▼' : '' }}
                <b>{{ tp(t).neu }}</b>
          </div>
            <div class="tm-ticker__zeitblock">
              <span v-if="t.minute != null" class="tm-ticker__minute">{{ tickerMinute(t) }}</span>
              <span v-if="t.zeit" class="tm-ticker__zeit">{{ uhrzeit(t.zeit) }}</span>
            </div>
          </div>
        </div>



        <div v-if="spielZeilen.length || gewaehlterSpieler" class="tm-ansichten">
          <button type="button" :class="['tm-ansicht', { 'is-active': ansicht === 'rang' }]" @click="ansicht = 'rang'">
            Rangliste
            <span v-if="zeige.platzBadge && meinPlatz" class="tm-ansicht__live tm-ansicht__platz">Platz <b>{{ meinPlatz }}</b></span>
          </button>
          <button type="button" :class="['tm-ansicht', { 'is-active': ansicht === 'spiele' }]" @click="ansicht = 'spiele'">
            Meine Spiele
            <span v-if="anzahlLive && !rundeAbgeschlossen" class="tm-ansicht__live">{{ anzahlLive }} live</span>
          </button>
        </div>

        <!-- Rangliste -->
        <div v-if="ansicht === 'rang'" class="tm-rangliste">
          <div class="tm-rangliste-scroll" v-auto-animate>

            <div
              v-for="eintrag in rangListe"
              :key="eintrag.registrationID"
              :data-registration-id="eintrag.registrationID"
              :class="[
                'tm-rangliste-zeile',
                {
                  'is-me': eintrag.registrationID === aktuellerUserId,
                  'tm-klickbar': controlling
                }
              ]"
              @click="controlling && waehleSpieler(eintrag)"
            >
              <span class="tm-rangliste-platz"><span>{{ eintrag.anzeigeRang }}</span></span>

              <span
                v-if="rangGeaendert(eintrag)"
                :class="['tm-rangliste-trend', trendKlasse(eintrag), 'hidden']"
                :aria-label="trendKlasse(eintrag) === 'tm-rangliste-trend--auf' ? 'Rang verbessert' : 'Rang verschlechtert'"
              >{{ trendSymbol(eintrag) }}</span>

              <span class="tm-rangliste-name">
                {{ eintrag.lastname + " " + eintrag.firstname}}
                <span v-if="eintrag.registrationID === aktuellerUserId" class="badge-me">Du</span>
              </span>

              <svg
                v-if="sparkMap[eintrag.registrationID]"
                :class="['tm-spark', `tm-spark--${sparkMap[eintrag.registrationID].trend}`]"
                viewBox="0 0 44 16" width="44" height="16" aria-hidden="true"
              >
                <polyline :points="sparkMap[eintrag.registrationID].punkte" fill="none" stroke="currentColor"
                          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle :cx="sparkMap[eintrag.registrationID].cx" :cy="sparkMap[eintrag.registrationID].cy" r="2" fill="currentColor"/>
              </svg>
              <span v-else class="tm-spark tm-spark--platzhalter"></span>

              <div class="tm-rangliste-punkte">
                <div class="tm-rangliste-punkte__wert">{{ formatPunkte(eintrag.value) }}</div>
                <div
                  v-if="deltaText(eintrag)"
                  :key="aenderung(eintrag).zeit"
                  :class="['tm-rangliste-delta', /^[−▼]/.test(deltaText(eintrag)) ? 'tm-rangliste-delta--minus' : 'tm-rangliste-delta--plus']"
                  :title="aenderungText(eintrag)"
                >{{ deltaText(eintrag) }}</div>
              </div>

            </div>

          </div>
        </div>

        <!-- Meine Spiele -->
        <div v-if="ansicht === 'spiele'" class="tm-tipps" :class="{ 'tm-tipps--kompakt': anzahlLive >= 4 }">

          <div v-if="!spielZeilen.length" class="tm-tipps-leer">
            <!--
            {{ gewaehlterSpieler ? 'Lade Tipps …' : 'Noch keine laufenden oder beendeten Spiele.' }}
            -->
          </div>

          <div v-if="1 == 2 && zeige.kopfkarte && liveProAktiv && wichtigstes" class="tm-kopf"><b>{{ wichtigstes }}</b></div>

          <div v-if="1 == 2 && zeige.topListen && liveProAktiv && anzahlLive >= 4 && topRunde && (topChancen.length || topGefahren.length)" class="tm-top">
            <div v-if="topChancen.length" class="tm-top__block tm-top__block--auf">
              <p class="tm-top__titel">Das wünschst du dir</p>
              <p v-for="(z, i) in topChancen" :key="'c' + i" class="tm-top__zeile">{{ i + 1 }}. {{ z.text }}<span class="tm-top__pkt">{{ z.punkte }}</span></p>
            </div>
            <div v-if="topGefahren.length" class="tm-top__block tm-top__block--ab">
              <p class="tm-top__titel">Hier soll kein Tor fallen</p>
              <p v-for="(z, i) in topGefahren" :key="'g' + i" class="tm-top__zeile">{{ i + 1 }}. {{ z.text }}<span class="tm-top__pkt">{{ z.punkte }}</span></p>
            </div>
          </div>

          <div v-if="zeige.topListen && liveProAktiv && anzahlLive >= 1 && topRunde && (topChancen.length || topGefahren.length)" class="tm-prog">
            <div v-if="topChancen[0]" class="tm-prog__box tm-prog__box--auf">
              <span class="tm-prog__l1"><i>▲</i><span class="tm-prog__b">⚽</span><span class="tm-prog__n">{{ topChancen[0].text.split(': ')[0].replace(/^Tor für /, '') }}</span></span>
              <span class="tm-prog__l2">auf {{ topChancen[0].text.split(': ')[1] || '' }}{{ topChancen[0].punkte }}</span>
            </div>
            <div v-if="topGefahren[0]" class="tm-prog__box tm-prog__box--ab">
              <span class="tm-prog__l1"><i>▼</i><span class="tm-prog__b">⚽</span><span class="tm-prog__n">{{ topGefahren[0].text.split(': ')[0].replace(/^Tor für /, '') }}</span></span>
              <span class="tm-prog__l2">auf {{ topGefahren[0].text.split(': ')[1] || '' }}</span>
            </div>
            <p v-if="bestfall" class="tm-prog__best">Je Spiel das beste Tor für dich: +{{ fmtPunkte(bestfall) }} Punkte</p>
          </div>

          <div v-if="gewaehlterSpieler" class="tm-spieler-hinweis">
            Tipps von <strong>{{ gewaehlterSpieler.name }}</strong>
            <button type="button" @click="gewaehlterSpieler = null">Meine Tipps</button>
          </div>

          <div class="tm-tipps__liste" ref="listeEl">
            <template v-for="g in gruppen" :key="g.key">
              <button
                v-if="g.titel"
                type="button"
                class="tm-grp"
                @click="g.zuklappbar && toggleGrp(g.key, $event)"
              >
                <span>{{ g.titel }} ({{ g.karten.length }})</span>
                <span v-if="g.zuklappbar" class="tm-grp__hint">{{ zu[g.key] ? 'aufklappen ▾' : 'zuklappen ▴' }}</span>
              </button>

              <template v-if="!(g.zuklappbar && zu[g.key])">
                <div
                  v-for="z in g.karten"
                  :key="z.id"
                  :class="['tm-tipp', 'tm-tipp--' + z.status, { 'tm-tipp--ok': z.richtig, 'tm-tipp--falsch': z.status === 'live' && !z.richtig }]"
                >
                  <div class="tm-tipp__kopf">
                    <span class="tm-tipp__status">
                      <template v-if="z.status === 'live'">LIVE<template v-if="spielZeit(z.spiel) && spielZeit(z.spiel) !== 'LIVE'"> · {{ spielZeit(z.spiel) }}</template></template>
                      <template v-else-if="z.status === 'beendet'">Beendet</template>
                      <template v-else>Geplant<template v-if="z.anstoss"> · {{ new Date(z.anstoss).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' }) }}</template></template>
                    </span>
                    <span class="tm-tipp__wert">{{ z.richtig ? '+' : '' }}{{ formatPunkte(z.auszahlung) }}</span>
                  </div>

                  <div class="tm-tipp__team tm-tipp__team-home">
                    <span class="tm-tipp__tor">{{ z.spiel?.heimtore ?? '–' }}</span>
                    <img v-if="z.spiel?.heimLogo" class="tm-tipp__logo" :src="z.spiel.heimLogo" alt="" loading="lazy" />
                    <span v-else class="tm-tipp__logo"></span>
                    <span class="tm-tipp__name">{{ z.spiel?.heim }}</span>
                    <span v-if="tippPille(z, 0)" class="tm-pill" :class="tippPille(z, 0).klasse">{{ tippPille(z, 0).text }}</span>
                    <span v-if="badge(z, 0)" class="tm-sb" :class="`tm-sb--${badge(z, 0).richtung}`">{{ badge(z, 0).l1 }}<small v-if="badge(z, 0).l2">{{ badge(z, 0).l2 }}</small></span>
                  </div>
                  <div class="tm-tipp__team">
                    <span class="tm-tipp__tor">{{ z.spiel?.austore ?? '–' }}</span>
                    <img v-if="z.spiel?.auswLogo" class="tm-tipp__logo" :src="z.spiel.auswLogo" alt="" loading="lazy" />
                    <span v-else class="tm-tipp__logo"></span>
                    <span class="tm-tipp__name">{{ z.spiel?.auswaerts }}</span>
                    <span v-if="tippPille(z, 1)" class="tm-pill" :class="tippPille(z, 1).klasse">{{ tippPille(z, 1).text }}</span>
                    <span v-if="badge(z, 1)" class="tm-sb" :class="`tm-sb--${badge(z, 1).richtung}`">{{ badge(z, 1).l1 }}<small v-if="badge(z, 1).l2">{{ badge(z, 1).l2 }}</small></span>
                  </div>

                  <div class="tm-tipp__fuss">
                    <span class="tm-tipp__chip"><em>1-2-X</em> {{ z.quote != null ? Number(z.quote).toFixed(2) : '–' }}</span>
                    <span class="tm-tipp__chip" :class="{ 'tm-tipp__chip--bonus': z.bonus10 > 0 }">
                      <em>Bonus</em> {{ Number(z.bonus10 ?? 0).toFixed(2) }}
                    </span>
                  </div>
                  <div v-if="zeige.braucht && liveProAktiv && brauchtText(z)" class="tm-tipp__braucht">{{ brauchtText(z) }}</div>
                  <div v-if="liveProAktiv && z.szenario && z.status === 'live' && zeige.erklaerung" class="tm-sz">
                    <p class="tm-sz__text">{{ szenarioText(z) }}</p>
                  </div>
                </div>
              </template>
            </template>
          </div>
          
          <div v-if="zeige.ueberblick && ueberblick.length" class="tm-ueb tm-ueb--fix">
            <span class="tm-ueb__titel"></span>
            <div class="tm-ueb__chips">
              <span v-for="u in ueberblick" :key="u.id" class="tm-ueb__chip" :class="['tm-ueb__chip--' + u.art, 'tm-ueb__chip--' + u.phase]">
                <b>{{ u.symbol }} {{ u.kurz }}</b><span>{{ u.tipp }}</span>
              </span>
            </div>
          </div>

          <div class="tm-tipps__summe">Runde bisher: {{ formatPunkte(summeSpiele) }}</div>
        </div>

      </template>
    </div>
  </template>

<script setup>
import { ref, unref, reactive, computed, nextTick, onMounted, onUnmounted, watch } from 'vue'
import { vAutoAnimate } from '@formkit/auto-animate/vue';
import { useLiveScores } from '../composables/useLiveScores.js'
import { vergleicheRang } from '../composables/rangSortierung.js'

const props = defineProps({
  companyId: { type: [Number, String], required: true },
  roundId: { type: [Number, String], required: true },
  wsUrl: { type: String, default: '' },
  isLive: { type: Boolean, default: false },
  apiBase: { type: String, default: '' },
  controlling: { type: Boolean, default: false },
})

const live = computed(() =>
  anzahlLive.value > 0 || (!!props.isLive && spielZeilen.value.length === 0)
)

const ladeEingeloggtenUser = () => {
  const userJson = localStorage.getItem('__oddsapp__client__');
  if (!userJson) return null;
  try {
    return JSON.parse(userJson).oddsRegistration.idodds_registration;
  } catch (e) {
    console.error('Fehler beim Parsen des Users aus dem LocalStorage', e);
    return null;
  }
};

const gewaehlterSpieler = ref(null)   // { registrationID, name }
const restEintraege = ref([])
const rundeAbgeschlossen = ref(false)
const rundeStand = ref(null)
const loading = ref(false)
const error = ref(null)
const aktuellerUserId = ref(ladeEingeloggtenUser());
const jetzt = ref(Date.now())
let uhr = null

// WICHTIG (Fix): rankingsProRunde/rankingGesamt jetzt mit destrukturiert - vorher fehlten die
// hier komplett im Scope, obwohl eine (nirgends verwendete) "liveRanking"-Computed weiter unten
// versucht hat, darauf zuzugreifen. Fallback-Zweig (nicht live) bekommt jetzt ebenfalls passende
// Platzhalter, damit die Struktur in beiden Fällen gleich aussieht.

const leer = {
  rangliste: ref([]), verbinden: () => {}, aufraeumen: () => {},
  rankingsProRunde: {}, rankingGesamt: ref([]), aenderungenProRunde: {},
  tickerEintraege: ref([]), meineTipps: ref([]), meineSpiele: ref([]),
  liveSpiele: {}, meldeRunde: () => {}, letztesUpdate: ref(null),
  wsStatus: ref('closed'), spielerTipps: ref({}), ladeSpielerTipps: () => {}
}

const {
  rangliste: socketRangliste,
  verbinden,
  aufraeumen,
  rankingsProRunde,
  rankingGesamt,
  tickerEintraege,
  meineTipps,
  meineSpiele,        // NEU
  liveSpiele,
  aenderungenProRunde,
  meldeRunde,
  letztesUpdate,
  wsStatus,
  spielerTipps,
  features,
  szenarien,
  szenarienTop,
  ladeSpielerTipps
} = props.wsUrl ? useLiveScores(props.wsUrl, ref([])) : leer

const liveProAktiv = computed(() => features.value.includes('live-pro'))

const ansicht = ref('rang')     // 'rang' | 'spiele'
const anzahlLive = computed(() => spielZeilen.value.filter(z => z.status === 'live').length)
const spielerZeilen = computed(() => {
  const g = gewaehlterSpieler.value
  if (!g) return []
  const rows = spielerTipps.value[`${props.roundId}_${g.registrationID}`] ?? []
  return rows.map(r => {
    const spiel = liveSpiele[r.matchId] ?? r.spielInfo ?? null
    return { ...r, spiel, status: spiel ? spielStatus(spiel) : null }
  })
})

const BEENDET = new Set(['FT', 'AET', 'PEN'])
const NICHT_LIVE = new Set(['NS', 'TBD', 'PST', 'CANC', 'ABD', 'AWD', 'WO'])

function tickerMinute(e) {
  if (e.minute == null || e.minute === '') return ''
  const basis = String(e.minute).replace(/'/g, '')
  const extra = typeof e.extra === 'number' && e.extra > 0 ? `+${e.extra}` : ''
  return `${basis}${extra}'`
}

const tippZeilen = computed(() =>
  meineTipps.value
    .map(t => ({ ...t, spiel: liveSpiele[t.matchId] ?? null }))
    .filter(t => t.spiel && !t.spiel.completed)
)

function uhrzeit(ms) {
  if (!ms) return ''
  return new Date(ms).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' })
}


const TOP_ANZAHL = 3
const topRunde = computed(() => szenarienTop.value[String(props.roundId)] ?? null)
const meinPlatz = computed(() =>
  liveProAktiv.value && anzahlLive.value > 0 && !rundeAbgeschlossen.value
    ? (topRunde.value?.platzJetzt ?? null)
    : null)

function topZeile(e) {
  const geteilt = e.gleich > 0 ? ' (geteilt)' : ''
  const punkte = e.delta > 0.005 ? ` · +${fmtPunkte(e.delta)}`
               : e.delta < -0.005 ? ` · ${fmtPunkte(e.delta)}`
               : ''
  return { text: `Tor für ${e.team}: Platz ${e.platz}${geteilt}`, punkte }
}
const topChancen = computed(() => (topRunde.value?.chancen ?? []).slice(0, TOP_ANZAHL).map(topZeile))
const topGefahren = computed(() => (topRunde.value?.gefahren ?? []).slice(0, TOP_ANZAHL).map(topZeile))


function waehleSpieler(e) {
  //console.log('[spieler] klick', e.registrationID, 'controlling:', props.controlling, 'roundId:', props.roundId)
  if (!props.controlling) return
  if (!props.roundId) return
  //console.log('[spieler] klick', e.registrationID, 'vorher:', gewaehlterSpieler.value?.registrationID)
  gewaehlterSpieler.value = {
    registrationID: e.registrationID,
    name: `${e.firstname ?? ''} ${e.lastname ?? ''}`.trim()
  }
  ladeSpielerTipps(props.roundId, e.registrationID)
  ansicht.value = 'spiele'
}

function spielStatus(spiel) {
  if (spiel.completed || BEENDET.has(spiel.kurz)) return 'beendet'
  if (NICHT_LIVE.has(spiel.kurz)) return 'geplant'                // noch nicht gestartet / abgesagt
  if (spiel.kurz == null && !(spiel.minute > 0)) return 'geplant' // Fallback ohne Kürzel: erst ab Minute 1
  return 'live'
}

const tippQuelle = computed(() => {
  //console.log('[tippQuelle] roundId=', props.roundId, 'meineSpiele roundIDs=', meineSpiele.value.map(t => t.roundID))

  const g = gewaehlterSpieler.value
  if (!g) return meineSpiele.value.filter(t => String(t.roundID) === String(props.roundId))
  return spielerTipps.value[`${props.roundId}_${g.registrationID}`] ?? []
})

function anstossMs(z) {
  const n = z.anstoss ? new Date(z.anstoss).getTime() : NaN
  return isNaN(n) ? null : n
}

const spielZeilen = computed(() => {
  const rang = { live: 0, geplant: 1, beendet: 2 }
  return tippQuelle.value
    .map(t => {
      //if (!liveSpiele[t.matchId]) console.log('[tipp] kein liveSpiel für', t.matchId, 'vorhanden:', Object.keys(liveSpiele))
      //console.log('[tipp]', t.matchId, 'liveSpiele-Keys:', Object.keys(liveSpiele))
      //console.log('[tipp]', t.matchId, JSON.stringify(liveSpiele[t.matchId]))
      //console.log('[spiel]', t.matchId, 'info.completed=', t.spielInfo?.completed, 'live=', !!liveSpiele[t.matchId], 'zeile aktiv')

      let spiel = (t.spielInfo?.completed ? t.spielInfo : null) ?? liveSpiele[t.matchId] ?? t.spielInfo ?? null
      // Logos: Live-Einträge haben keine. Quelle sind die Tipp-Felder heimLogo / ausLogo, sonst spielInfo
      if (spiel && !spiel.heimLogo) {
        const heimLogo = t.heimLogo ?? t.spielInfo?.heimLogo ?? null
        const auswLogo = t.auswLogo ?? t.spielInfo?.auswLogo ?? null
        if (heimLogo || auswLogo) spiel = { ...spiel, heimLogo, auswLogo }
      }
      const basis = (t.quote ?? 0) * (t.einsatz ?? 1)
      const abgeleitet = t.richtig ? Math.max(0, Math.round((t.auszahlung - basis) * 100) / 100) : 0
      const bonus10 = t.bonus10 > 0 ? t.bonus10 : abgeleitet
      const szenario = szenarien.value[`${t.roundID}_${t.matchid}`] ?? null
      return { ...t, spiel, bonus10, szenario, status: spiel ? spielStatus(spiel) : 'geplant' }
    })
    .sort((a, b) => {
      if (rang[a.status] !== rang[b.status]) return rang[a.status] - rang[b.status]
      const za = anstossMs(a), zb = anstossMs(b)
      if (a.status === 'live') return (b.spiel?.minute ?? 0) - (a.spiel?.minute ?? 0)
      if (a.status === 'geplant') return (za ?? Infinity) === (zb ?? Infinity) ? 0 : (za ?? Infinity) < (zb ?? Infinity) ? -1 : 1   // früheste zuerst
      return (zb ?? 0) - (za ?? 0)                                                                                                  // beendet: zuletzt angepfiffen zuerst
    })
})

function fmtPunkte(x) {
  return (Math.round(x * 100) / 100).toLocaleString('de-AT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function szenarioText(z) {
  const s = z.szenario
  const seiten = [{ name: z.spiel?.heim, d: s.deltaHeim }, { name: z.spiel?.auswaerts, d: s.deltaAus }]
  const teile = []
  const [a, b] = seiten
  const gleich = Math.abs(a.d - b.d) < 0.005
  if (gleich && a.d > 0.005) teile.push(`Jedes Tor bringt dir +${fmtPunkte(a.d)}.`)
  else if (gleich && a.d < -0.005) teile.push(`Jedes Tor kostet dich ${fmtPunkte(-a.d)}.`)
  else for (const x of seiten) {
    if (x.d > 0.005) teile.push(`Ein Tor für ${x.name} bringt dir +${fmtPunkte(x.d)}.`)
    else if (x.d < -0.005) teile.push(`Ein Tor für ${x.name} kostet dich ${fmtPunkte(-x.d)}.`)
  }
  return teile.length ? teile.join(' ') : 'Ein Tor ändert deine Punkte nicht.'
}

function szenarioChips(z) {
  const s = z.szenario
  return [
    { team: z.spiel?.heim, platz: s.platzHeim, gleich: s.gleichHeim, delta: s.deltaHeim },
    { team: z.spiel?.auswaerts, platz: s.platzAus, gleich: s.gleichAus, delta: s.deltaAus }
  ].map(c => ({
    delta: c.delta,
    platz: c.platz,
    gleich: c.gleich,
    bleibt: c.platz === s.platzJetzt,
    richtung: c.platz < s.platzJetzt ? 'auf' : c.platz > s.platzJetzt ? 'ab' : 'gleich',
    text: (c.platz === s.platzJetzt
      ? `Tor ${c.team}: Platz ${c.platz} bleibt`
      : `Tor ${c.team}: Platz ${s.platzJetzt} → ${c.platz}`) + (c.gleich > 0 ? ' (geteilt)' : '')
  }))
}

function tore(n) { return n === 1 ? '1 Tor' : `${n} Tore` }

function brauchtText(z) {
  if (z.status !== 'live' || !z.spiel) return ''
  const m = String(z.tipp ?? '').match(/^\s*(\d+)\s*:\s*(\d+)\s*$/)
  if (!m) return ''
  const ta = Number(m[1]), tb = Number(m[2])
  const h = Number(z.spiel.heimtore ?? 0), g = Number(z.spiel.austore ?? 0)
  const heim = z.spiel.heim || 'Heim', gast = z.spiel.auswaerts || 'Gast'
  const tend = (a, b) => Math.sign(a - b)
  const tendOk = tend(h, g) === tend(ta, tb)

  if (h === ta && g === tb) return 'Passt exakt. Ein weiteres Tor kostet den Bonus.'
  
  // exaktes Ergebnis noch erreichbar (Tore können nur dazukommen)
  if (h <= ta && g <= tb) {
    const teile = []
    if (ta - h > 0) teile.push(`${tore(ta - h)} für ${heim}`)
    if (tb - g > 0) teile.push(`${tore(tb - g)} für ${gast}`)
    return `Exakt fehlt: ${teile.join(' + ')}` + (tendOk ? '' : ' · Tendenz noch offen')
  }

  // exakt nicht mehr möglich
  if (tendOk) return 'Exakt nicht mehr möglich · Tendenz passt'
  const t = tend(ta, tb)
  if (t > 0) return `Exakt vorbei · Tendenz braucht ${tore(g - h + 1)} für ${heim}`   // t > 0
  if (t < 0) return `Exakt vorbei · Tendenz braucht ${tore(h - g + 1)} für ${gast}`   // t < 0
  return h > g
    ? `Exakt vorbei · Tendenz braucht ${tore(h - g)} für ${gast}`
    : `Exakt vorbei · Tendenz braucht ${tore(g - h)} für ${heim}`
}

const summeSpiele = computed(() =>
  spielZeilen.value.reduce((s, z) => s + (z.auszahlung || 0), 0))


const tickerAnzeige = computed(() => {
  const ids = new Set(spielZeilen.value.map(z => String(z.matchId)))
  return tickerEintraege.value.filter(t => t.matchId != null && ids.has(String(t.matchId)))
})

const eintraege = computed(() => {
  const roundIdNum = Number(props.roundId)
  const liveDaten = (!roundIdNum || roundIdNum === 0)
    ? rankingGesamt.value
    : rankingsProRunde[roundIdNum]

  if (liveDaten && liveDaten.length > 0) return liveDaten
  return restEintraege.value
})

const keineDatenVorhanden = computed(() => {
  return !loading.value && !error.value && eintraege.value.length === 0
})

function aenderung(eintrag) {
  return aenderungenProRunde[`${Number(props.roundId)}_${eintrag.registrationID}`] ?? null
}

function aenderungText(eintrag) {
  const a = aenderung(eintrag)
  if (!a) return ''
  const zeit = new Date(a.zeit).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' })
  return `${zeit} · vorher Platz ${a.rangAlt} · ${formatPunkte(a.punkteAlt)}`
}

function deltaText(eintrag) {
  const a = aenderung(eintrag)
  if (!a) return ''
  const dp = Number(eintrag.value ?? 0) - Number(a.punkteAlt ?? 0)
  if (Math.abs(dp) > 1e-9) return (dp > 0 ? '+' : '−') + Math.abs(dp).toFixed(2)
  const dr = a.rangAlt - eintrag.ranking
  return dr > 0 ? `▲${dr}` : dr < 0 ? `▼${-dr}` : ''
}

async function ladenPerRest() {
  loading.value = true
  error.value = null

  if (!props.roundId || !props.companyId) {
    console.warn("⚠️ Warten auf Props: roundId oder companyId fehlen noch.", {
      roundId: props.roundId,
      companyId: props.companyId
    });
    loading.value = false // sonst bleibt die Ladeanzeige für immer hängen
    return;
  }

  if (props.roundId == 0) {
    loading.value = false
    return;
  }

  const url = `${props.apiBase}/${props.roundId}/ranking?companyID=${props.companyId}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Server antwortete mit Status: ${response.status}`);
    }

    const daten = await response.json();
    loading.value = false

    if (daten && Array.isArray(daten.rankingsLive)) {
      restEintraege.value = daten.rankingsLive;
      rundeAbgeschlossen.value = !!daten.abgeschlossen
      rundeStand.value = daten.stand ?? null
    } else {
      console.error("❌ Fehler: 'daten.rankingsLive' ist kein gültiges Array!", daten);
      restEintraege.value = [];
      rundeAbgeschlossen.value = false
      rundeStand.value = null
    }

  } catch (error) {
    console.error("❌ Fehler beim Laden der REST-Daten:", error);
    restEintraege.value = [];
    rundeAbgeschlossen.value = false
    rundeStand.value = null
  } finally {
    loading.value = false // egal ob Erfolg oder Fehler - Ladeanzeige darf nicht hängen bleiben
  }
}

const angezeigteEintraege = computed(() => {
  if (!eintraege.value || eintraege.value.length === 0) return { liste: [], userIstGetrennt: false };

  const top30 = eintraege.value.slice(0, 10);
  const istInTop30 = top30.some(e => e.registrationID === aktuellerUserId.value);

  if (!istInTop30) {
    const eigenerEintrag = eintraege.value.find(e => e.registrationID === aktuellerUserId.value);
    if (eigenerEintrag) {
      return {
        liste: [...top30, { ...eigenerEintrag, istLoserAnhaenger: true }].sort(vergleicheRang),
        userIstGetrennt: true
      };
    }
  }

  return {
    liste: top30,
    userIstGetrennt: false
  };
});

const rangListe = computed(() => {
  const werte = (eintraege.value ?? []).map(e => Number(e.value) || 0).sort((a, b) => a - b)
  const mehrAls = (v) => {
    let lo = 0, hi = werte.length
    while (lo < hi) {
      const mid = (lo + hi) >>> 1
      if (werte[mid] > v + 1e-9) hi = mid; else lo = mid + 1
    }
    return werte.length - lo
  }
  const liste = [...(angezeigteEintraege.value?.liste ?? [])].sort(vergleicheRang)
  return liste.map(e => ({ ...e, anzeigeRang: 1 + mehrAls(Number(e.value) || 0) }))
})

const verlauf = ref({})          // registrationID -> [[zeit, rang, punkte], ...]
let verlaufTimer = null
let letzterVerlaufAbruf = 0

async function ladeVerlauf() {
  if (!props.apiBase || Number(props.roundId) <= 0) return     // Gesamtwertung hat keinen Verlauf
  const ids = rangListe.value.map(e => e.registrationID)
  if (!ids.length) return
  letzterVerlaufAbruf = Date.now()
  try {
    const r = await fetch(`${props.apiBase}/${props.roundId}/history?companyID=${props.companyId}&ids=${ids.slice(0, 50).join(',')}&max=15`)
    if (!r.ok) return
    const d = await r.json()
    verlauf.value = d.serien ?? {}
  } catch (e) { /* Verlauf ist optional, Fehler bleiben still */ }
}

function planeVerlauf() {
  clearTimeout(verlaufTimer)
  const warte = Math.max(1500, 5000 - (Date.now() - letzterVerlaufAbruf))   // höchstens alle 5 s
  verlaufTimer = setTimeout(ladeVerlauf, warte)
}

watch(
  () => rangListe.value.map(e => `${e.registrationID}:${e.anzeigeRang}:${e.value}`).join('|'),
  planeVerlauf,
  { immediate: true }
)

const sparkMap = computed(() => {
  const b = 44, h = 16, rand = 2
  const m = {}
  for (const [id, reihe] of Object.entries(verlauf.value ?? {})) {
    if (!reihe || reihe.length < 2) continue
    const raenge = reihe.map(p => p[1])
    const min = Math.min(...raenge), max = Math.max(...raenge)
    const spanne = Math.max(max - min, 2)        // kleine Schwankungen nicht aufblasen
    const pts = raenge.map((r, i) => {
      const x = rand + (i * (b - 2 * rand)) / (raenge.length - 1)
      const y = max === min ? h / 2 : rand + ((r - min) / spanne) * (h - 2 * rand)   // Rang 1 oben
      return [x, y]
    })
    const erster = raenge[0], letzter = raenge[raenge.length - 1]
    m[id] = {
      punkte: pts.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' '),
      cx: pts[pts.length - 1][0],
      cy: pts[pts.length - 1][1],
      trend: letzter < erster ? 'auf' : letzter > erster ? 'ab' : 'gleich'
    }
  }
  return m
})

function rangGeaendert(eintrag) {
  return eintrag.rankingPrevious != null && eintrag.rankingPrevious !== 0 && eintrag.rankingPrevious !== eintrag.ranking
}
function trendKlasse(eintrag) {
  return eintrag.rankingPrevious > eintrag.ranking ? 'tm-rangliste-trend--auf' : 'tm-rangliste-trend--ab'
}
function trendSymbol(eintrag) {
  return eintrag.rankingPrevious > eintrag.ranking ? '▲' : '▼'
}
function vollerName(eintrag) {
  const teile = [eintrag.firstname, eintrag.lastname].filter(Boolean)
  return teile.length > 0 ? teile.join(' ') : `Teilnehmer ${eintrag.registrationID}`
}
function formatPunkte(wert) {
  return Number(wert ?? 0).toFixed(2)
}

function spielZeit(s) {
  if (!s) return ''
  switch (s.kurz) {
    case 'HT': return 'HT'
    case 'BT': return 'Pause'
    case 'P': return 'Elfm.'
    case 'INT':
    case 'SUSP': return 'Unterbr.'
    case 'FT':
    case 'AET':
    case 'PEN': return 'Ende'
    default: {
      if (s.minute == null) return 'LIVE'                       // 1H, 2H, ET, LIVE
      const extra = typeof s.extra === 'number' && s.extra > 0 ? `+${s.extra}` : ''
      return `${s.minute}${extra}'`
    }
  }
}

const standText = computed(() => {
  if (!letztesUpdate.value) return ''
  const d = new Date(letztesUpdate.value)
  return d.toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
})

const standAlter = computed(() => {
  if (!letztesUpdate.value) return 0
  return Math.max(0, Math.round((jetzt.value - letztesUpdate.value) / 1000))
})

const verbunden = computed(() => wsStatus.value === 'verbunden')
const veraltet = computed(() => !verbunden.value || standAlter.value > 150)   // > 2,5 Minuten ohne Nachricht

onMounted(() => {

  uhr = setInterval(() => { jetzt.value = Date.now() }, 1000)

  if (props.isLive && props.wsUrl) {
    verbinden()
    meldeRunde(props.roundId)
  } else {
    ladenPerRest()
  }
})

onUnmounted(() => {

  clearTimeout(abschlussTimer)
  clearTimeout(verlaufTimer)
  clearInterval(uhr)

  if (typeof aufraeumen === 'function') {
    aufraeumen()
  }
})

watch(() => props.roundId, (newRoundId) => {
  if (!newRoundId) return;

  gewaehlterSpieler.value = null

  meldeRunde(newRoundId);      // NEU

  restEintraege.value = [];
  ladenPerRest();

}, { immediate: true });

// Tipps des gewählten Spielers neu laden, sobald sich die Rangliste ändert
let tippsNeuTimer = null
watch(
  () => rangListe.value.map(e => `${e.registrationID}:${e.value}`).join('|'),
  () => {
    const g = gewaehlterSpieler.value
    if (!g) return
    clearTimeout(tippsNeuTimer)
    tippsNeuTimer = setTimeout(() => ladeSpielerTipps(props.roundId, g.registrationID), 800)
  }
)


let abschlussTimer = null
async function pruefeAbschluss(versuch = 0) {
  clearTimeout(abschlussTimer)
  if (!props.roundId || !props.companyId || props.roundId == 0 || rundeAbgeschlossen.value) return
  try {
    const r = await fetch(`${props.apiBase}/${props.roundId}/ranking?companyID=${props.companyId}`)
    if (r.ok) {
      const d = await r.json()
      if (d?.abgeschlossen) {
        rundeAbgeschlossen.value = true
        rundeStand.value = d.stand ?? null
        return
      }
    }
  } catch (e) { /* still, nächster Versuch */ }
  if (versuch < 10) abschlussTimer = setTimeout(() => pruefeAbschluss(versuch + 1), 30000)
}

watch(live, (neu, alt) => { if (alt && !neu) pruefeAbschluss() })


// Platz-Wechsel für den Ticker (nur Widget, useLiveScores bleibt unberührt)
let platzDavor = null
let platzDavorZeit = 0
watch(meinPlatz, (neu, alt) => { platzDavor = alt; platzDavorZeit = Date.now() }, { flush: 'sync' })

// Platz je Ticker-Eintrag: wird einmal gesetzt (Platz nach dem Tor) und danach nie mehr verändert.
// Schlüssel statt Objekt, damit es auch hält, wenn die Liste neu aufgebaut wird.
const tickerPlatz = reactive({})
const tickerKey = (t) => `${t.matchId}:${t.heimtore}:${t.austore}:${t.minute}`
const tp = (t) => tickerPlatz[tickerKey(t)] ?? null

watch(tickerEintraege, (liste) => {
  const offen = (liste ?? []).filter(t => tickerPlatz[tickerKey(t)] === undefined)
  if (!offen.length) return
  const neu = meinPlatz.value ?? null
  // alter Wert nur, wenn der Wechsel gerade eben im selben Frame kam
  const alt = (platzDavor != null && Date.now() - platzDavorZeit < 1000) ? platzDavor : neu
  platzDavor = null
  for (const t of offen) {
    // schon ältere Einträge (z. B. nach erneutem Öffnen): Platz von damals ist unbekannt, nichts anzeigen
    const alter = t.zeit ? Date.now() - t.zeit : 0
    tickerPlatz[tickerKey(t)] = alter > 90000 ? { alt: null, neu: null } : { alt, neu }
  }
})



const zu = reactive({ ruhig: true, beendet: true })

const ohneEinfluss = (z) => {
  if (!zeige.ohneEinfluss) return false
  if (z.status !== 'live' || !z.szenario) return false
  const c = szenarioChips(z)
  return c.length > 0 && c.every(x => x.richtung === 'gleich')
}

// Anzeige-Schalter: true = sichtbar. Zum Testen im Browser überschreibbar:
// localStorage.setItem('tm:zeige', JSON.stringify({ kopfkarte: false })) und neu laden
function ladeZeige() {
  try { return JSON.parse(localStorage.getItem('tm:zeige') || '{}') } catch { return {} }
}
const zeige = reactive({
  platzBadge: true,     // Platz am Rangliste-Button
  kopfkarte: true,      // "Wichtigstes Spiel gerade"
  ueberblick: true,     // "Deine Tipps auf einen Blick"
  topListen: true,      // "Das wünschst du dir" / "Hier soll kein Tor fallen"
  ohneEinfluss: false,  // Gruppe "Ohne Einfluss auf dich" (aus: Punkte/Bonus werden nicht berücksichtigt)
  braucht: true,        // "Exakt fehlt: …"
  erklaerung: false,    // "Ein Tor für … bringt dir …" (Punkte stehen jetzt im Chip)
  chips: true,          // Ausgänge mit ▲/▼
  tickerPlatz: true,    // Platz im Ticker
  ...ladeZeige()
})

const kurzName = (n) => (n ?? '').replace(/[^A-Za-zÄÖÜäöüß]/g, '').slice(0, 3).toUpperCase()

const ueberblick = computed(() => spielZeilen.value.map(z => {
  const phase = z.status === 'live' ? 'live' : z.status === 'beendet' ? 'fertig' : 'geplant'
  const art = phase === 'geplant' ? 'offen' : (z.richtig ? 'ok' : 'falsch')
  return {
    id: z.id,
    art,
    phase,
    symbol: art === 'ok' ? '✓' : art === 'falsch' ? '✕' : '·',
    kurz: kurzName(z.spiel?.heim),
    tipp: z.tipp
  }
}))

const pfeil = (richtung) => richtung === 'auf' ? '▲' : richtung === 'ab' ? '▼' : '='

// Exakter Tipp noch erreichbar? (Tore können nur dazukommen)
const exaktMoeglich = (z) => {
  const m = String(z.tipp ?? '').match(/^\s*(\d+)\s*:\s*(\d+)\s*$/)
  if (!m || !z.spiel) return true
  return Number(z.spiel.heimtore ?? 0) <= Number(m[1]) && Number(z.spiel.austore ?? 0) <= Number(m[2])
}

// Ein Tor ändert weder Punkte noch Platz, und der exakte Tipp ist nicht mehr erreichbar
const ruhig = (z) => {
  const s = z.szenario
  if (z.status !== 'live' || !s) return false
  if (Math.abs(s.deltaHeim) > 0.005 || Math.abs(s.deltaAus) > 0.005) return false
  if (exaktMoeglich(z)) return false
  return szenarioChips(z).every(c => c.richtung === 'gleich')
}

// Summe der besten Tore je Spiel (nur bei mindestens zwei Spielen, sonst steht es schon im Kopfblock)
const bestfall = computed(() => {
  let summe = 0, n = 0
  for (const z of spielZeilen.value) {
    if (z.status !== 'live' || !z.szenario) continue
    const b = Math.max(0, z.szenario.deltaHeim, z.szenario.deltaAus)
    if (b > 0.005) { summe += b; n++ }
  }
  return n >= 2 ? summe : 0
})


// Titel der Gruppe "geplant" nach dem frühesten Anstoß
const geplantTitel = computed(() => {
  const zeiten = spielZeilen.value.filter(z => z.status === 'geplant').map(anstossMs).filter(n => n != null)
  if (!zeiten.length) return 'Geplant'
  const erster = Math.min(...zeiten)
  if (erster - jetzt.value <= 60 * 60 * 1000) return 'Gleich geht es los'
  const d = new Date(erster)
  const uhr = d.toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' })
  if (d.toDateString() === new Date(jetzt.value).toDateString()) return `Heute ab ${uhr}`
  if (d.toDateString() === new Date(jetzt.value + 86400000).toDateString()) return `Morgen ab ${uhr}`
  return `${d.toLocaleDateString('de-AT', { weekday: 'short', day: '2-digit', month: '2-digit' })} ab ${uhr}`
})

// Gruppe auf-/zuklappen; beim Aufklappen an den oberen Rand der Liste scrollen
function toggleGrp(key, ev) {
  const el = ev?.currentTarget
  zu[key] = !zu[key]
  if (zu[key] || !el) return
  nextTick(() => {
    const liste = el.closest('.tm-tipps__liste')
    if (!liste) return
    liste.scrollTo({ top: liste.scrollTop + el.getBoundingClientRect().top - liste.getBoundingClientRect().top, behavior: 'smooth' })
  })
}

// Tipp je Team (Pille): grün = Torzahl stimmt, rot = schon zu viele Tore, grau = noch offen
function tippPille(z, seite) {
  const m = String(z.tipp ?? '').match(/^\s*(\d+)\s*:\s*(\d+)\s*$/)
  if (!m) return null
  const tipp = Number(m[seite + 1])
  const roh = seite === 0 ? z.spiel?.heimtore : z.spiel?.austore
  if (z.status === 'geplant' || roh == null) return { text: tipp, klasse: '' }
  const stand = Number(roh)
  const klasse = stand === tipp ? 'tm-pill--ok' : (stand > tipp || z.status === 'beendet') ? 'tm-pill--x' : ''
  return { text: tipp, klasse }
}

// Szenario-Badge in der Teamzeile (seite 0 = Heim, 1 = Gast)
function badge(z, seite) {
  if (!zeige.chips || !liveProAktiv.value || !z.szenario || z.status !== 'live') return null
  const c = szenarioChips(z)[seite]
  if (!c) return null
  const l1 = c.bleibt ? `bleibt ${c.platz}` : `Platz ${c.platz}`
  const teile = []
  if (c.gleich > 0) teile.push('geteilt')
  if (Math.abs(c.delta) > 0.005) teile.push(`${c.delta > 0 ? '+' : '-'}${fmtPunkte(Math.abs(c.delta))}`)
  const l2 = [c.richtung === 'gleich' ? '' : pfeil(c.richtung), teile.join(' · ')].filter(Boolean).join(' ')
  return { richtung: c.richtung, l1, l2 }
}

const gruppen = computed(() => {
  const g = { live: [], ruhig: [], geplant: [], beendet: [] }
  for (const z of spielZeilen.value) {
    if (z.status === 'live') (ohneEinfluss(z) ? g.ruhig : g.live).push(z)
    else if (z.status === 'beendet') g.beendet.push(z)
    else g.geplant.push(z)
  }
  g.live.sort((a, b) => wichtig(b) - wichtig(a))
  return [
    { key: 'live', titel: null, karten: g.live },
    { key: 'ruhig', titel: 'Ohne Einfluss auf dich', karten: g.ruhig, zuklappbar: true },
    { key: 'geplant', titel: geplantTitel.value, karten: g.geplant },
    // nur zuklappbar, wenn es noch etwas anderes gibt; sonst gleich offen
    { key: 'beendet', titel: 'Schon beendet', karten: g.beendet, zuklappbar: (g.live.length + g.ruhig.length + g.geplant.length) > 0 }
  ].filter(x => x.karten.length)
})

// Alle Spiele beendet: "Schon beendet" steht offen; Liste nach oben, damit man nicht mitten drin landet
const listeEl = ref(null)
const nurBeendet = computed(() => gruppen.value.length === 1 && gruppen.value[0].key === 'beendet')
watch(nurBeendet, (jetztNur, davor) => {
  if (jetztNur && !davor) {
    zu.beendet = false
    nextTick(() => listeEl.value?.scrollTo({ top: 0, behavior: 'smooth' }))
  }
})

const uebersicht = computed(() => {
  const l = spielZeilen.value
  const live = l.filter(x => x.status === 'live')
  const beendet = l.filter(x => x.status === 'beendet').length
  return {
    live: live.length,
    richtig: live.filter(x => x.richtig).length,
    beendet,
    geplant: l.length - live.length - beendet
  }
})

const wichtigstesEintrag = computed(() => {
  const r = topRunde.value
  const kand = [...(r?.chancen ?? []), ...(r?.gefahren ?? [])]
  if (!kand.length) return null
  return kand.reduce((a, b) => Math.abs(b.delta) > Math.abs(a.delta) ? b : a)
})

const spielZuMatchid = (matchid) =>
  Object.values(unref(liveSpiele) ?? {}).find(s => s.matchid === String(matchid)) ?? null

const wichtigstes = computed(() => {
  const e = wichtigstesEintrag.value
  if (!e) return null
  const s = spielZuMatchid(e.matchid)
  const spiel = s ? `${s.heim} – ${s.auswaerts}` : e.team
  const wirkung = e.platz > (topRunde.value?.platzJetzt ?? e.platz) ? 'fällst du' : 'steigst du'
  return `${spiel} · bei einem Tor für ${e.team} ${wirkung} auf Platz ${e.platz}`
})

const wichtig = (z) => {
  const r = topRunde.value
  const matchid = z.spiel?.matchid
  if (!matchid) return 0
  return Math.max(0, ...[...(r?.chancen ?? []), ...(r?.gefahren ?? [])]
    .filter(e => String(e.matchid) === matchid)
    .map(e => Math.abs(e.delta)))
}

</script>

<style lang="css">

.tm-rangliste {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding:0px 10px 6px 10px;
}

.tm-rangliste-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.tm-rangliste-scroll .tm-rangliste-zeile.is-me {
  position: sticky;
  top: 0;
  bottom: 0;
  z-index: 2;
  background-color: var(--tm-me-bg, #eaf6ff);   /* deckend, passend zu deinem Blau */
}

.tm-rangliste-scroll .tm-rangliste-zeile.tm-klickbar {
  cursor:pointer;
}

.tm-rangliste-wrapper {
  display: flex;
  flex-direction: column;
  height:100%;
  max-width: 600px;
  margin: 0 auto;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #2d3748;
  background-color: #f7fafc;
  padding: 0px;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}

.tm-ranking-header {
  display:flex;
  align-items:center;
  margin:4px 4px 4px 4px;
}

.tm-ranking-header .tm-stand{
  flex:1;
  justify-content: right;
}

.tm-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px 20px;
  text-align: center;
  color: #718096;
  font-size: 1rem;
}

.tm-state--column {
  flex-direction: column;
}

.tm-state--error {
  color: #e53e3e;
}

.tm-state__spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #cbd5e0;
  border-top-color: #3182ce;
  border-radius: 50%;
  animation: tm-spin 0.8s linear infinite;
}

@keyframes tm-spin {
  to { transform: rotate(360deg); }
}

.tm-retry-btn {
  margin-top: 12px;
  background: #3182ce;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.tm-retry-btn:hover {
  background: #2b6cb0;
}

.tm-rangliste-live-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff5f5;
  color: #e53e3e;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: 1px solid #fed7d7;
}

.tm-live-dot {
  width: 8px;
  height: 8px;
  background-color: #e53e3e;
  border-radius: 50%;
  animation: tm-pulse 1.5s infinite;
}

@keyframes tm-pulse {
  0% { transform: scale(0.95); opacity: 0.8; }
  50% { transform: scale(1.2); opacity: 1; }
  100% { transform: scale(0.95); opacity: 0.8; }
}

.tm-rangliste-zeile {
  display: grid;
  grid-template-columns: 40px 1fr 44px 50px;
  align-items: center;
  background: #ffffff;
  padding: 5px 10px 5px 3px;
  border-radius: 12px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
  border: 1px solid #edf2f7;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.tm-rangliste-zeile:hover {
  /*
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
  */
}

.tm-rangliste-platz {
  text-align: center;
  font-weight: 700;
  font-size: 1.05rem;
  color: #718096;
  font-variant-numeric: tabular-nums;
}

.tm-rangliste-trend {
  text-align: left;
  font-size:20px;
  font-weight: bold;
}
.tm-rangliste-trend--auf { color: #48bb78; }
.tm-rangliste-trend--ab { color: #f56565; }
.tm-rangliste-trend--platzhalter { visibility: hidden; }

.tm-rangliste-name {
  font-weight: 500;
  color: #4a5568;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
}

.is-me {
  background: #ebf8ff !important;
  border-color: #90cdf4 !important;
  box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.2);
}
.is-me .tm-rangliste-name {
  font-weight: 700;
  color: #2b6cb0;
}

.badge-me {
  display:inline-flex;
  background: #5b7792;
  color: white;
  font-size: 14px;
  padding: 2px 6px;
  border-radius: 6px;
  vertical-align: middle;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.tm-rangliste-punkte {
  text-align: right;
  font-weight: 700;
  color: #1a202c;
  font-variant-numeric: tabular-nums;
}

.tm-rangliste-punkte .tm-rangliste-punkte__wert {
  font-family: 14px;
}

.tm-rangliste-punkte .tm-rangliste-delta {
  font-size: 11px;
  color:gray;
}

.tm-separator {
  grid-column: 1 / -1;
  text-align: center;
  color: #a0aec0;
  font-size: 0.85rem;
  padding: 12px 0 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.sep-text {
  background: #e2e8f0;
  color: #4a5568;
  padding: 3px 10px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.tm-ticker {
  max-height:140px;
  overflow:auto;
  padding:0px 10px;
  margin-bottom:4px;
}

.tm-ticker__spiel_tor {
  font-weight:700;
  width:18px;
}

.tm-ticker__spiel_team--tor { font-weight: 700; }

.tm-ticker__ball {
  width:30px;
}

.tm-ticker__spiel {
  display:block;
}

.tm-ticker__spiel_team {
  display:flex;
}

.tm-ticker__eintrag {
  display:flex;
  align-items:center;
}
.tm-ticker__spiel {
  flex:1;
}
.tm-ticker__zeitblock { width:50px; display: flex; flex-direction: column; align-items: flex-end; line-height: 1.15; }
.tm-ticker__zeit { font-size: 11px; opacity: .6;margin-top:3px; }

.tm-ansichten { display: flex; gap: 4px; margin: 0 0 8px; padding:0px 10px;}
.tm-ansicht {
  flex: 1; padding: 8px 10px; border: 0; border-radius: 8px; cursor: pointer;
  font: inherit; font-size: 13px; font-weight: 600;
  background: rgba(0,0,0,.05); color: inherit; opacity: .7;
}
.tm-ansicht__platz { margin-left: 6px; }
.tm-ansicht__platz b { font-weight: 800; font-size: 1.15em; }
.tm-ansicht.is-active { opacity: 1; background: rgba(0,0,0,.12); }
.tm-ansicht__live {
  margin-left: 6px; padding: 1px 6px; border-radius: 999px;
  font-size: 11px; color: #fff; background: #d32f2f;
}

/* Der Spiele-Block bekommt dieselbe Höhe wie die Rangliste und scrollt in sich */
.tm-tipps { flex: 1; min-height: 0; display: flex; flex-direction: column; margin: 0; }
.tm-tipps__liste { 
  flex: 1; min-height: 0; max-height: none; overflow-y: auto; 
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding:0px 10px;
}

.tm-tipp { background: var(--tm-surface-2, #eef1f5); border-radius: 12px; 
          padding: 5px 7px;
          border-left: 4px solid #d64545; display: flex; flex-direction: column; 
          gap: 0px; margin-bottom: 8px; 
        }
.tm-tipp--ok { background: #e4f3ea; border-left-color: #1d9e75; }
.tm-tipp--falsch { background: #fbeeee; }
.tm-tipp { margin-bottom: 0; }
.tm-sz__ruhig { margin: 0; font-size: 12px; opacity: .7; }
.tm-tipp--geplant:not(.tm-tipp--ok) { border-left-color: #9ca3af; }
.tm-tipp__kopf { display: flex; justify-content: space-between; align-items: center; }
.tm-tipp__status { font-size: 12px; font-weight: 700; color: #6b7280; letter-spacing: .02em; }
.tm-tipp--live .tm-tipp__status { color: #d64545; }
.tm-tipp__wert { font-size: 18px; font-weight: 800; color: #4b5563; }
.tm-tipp--ok .tm-tipp__wert { color: #1d7a5a; }
.tm-tipp__team { display: flex; align-items: center; gap: 8px; }
.tm-tipp__team-home { margin-bottom:3px; }
.tm-tipp__logo { width: 20px; height: 20px; object-fit: contain; flex: none; display: inline-block; }
.tm-tipp__name { flex: 1 1 auto; min-width: 0; font-size: 13px; font-weight: 600;
                 line-height:15px; }
.tm-tipp__tor { flex: none; width: 20px; text-align: center; font-size: 16px; font-weight: 800; }
.tm-tipp__fuss { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; }
.tm-tipp__chip { font-size: 12px; font-weight: 700; padding: 3px 8px; border-radius: 999px;
                 background: rgba(0,0,0,.06); color: #374151; }
.tm-tipp__chip em { font-style: normal; font-weight: 500; color: #6b7280; margin-right: 3px; }
.tm-tipp__chip--bonus { background: #1d9e75; color: #fff; }
.tm-tipp__chip--bonus em { color: #d7f1e6; }

.tm-tipps__summe { text-align: right; font-weight: 700; font-size: 13px; padding-right:10px; }

.tm-stand { display: flex; align-items: center; gap: 6px; margin: 0 0 0px; font-size: 11px; opacity: .7; }
.tm-stand__punkt { width: 7px; height: 7px; border-radius: 50%; background: #2e9e5b; }
.tm-stand--alt { opacity: .55; }
.tm-stand--alt .tm-stand__punkt { background: #9e9e9e; }

.tm-spieler-tipps { border-top: 1px solid rgba(128,128,128,.3); padding: 8px 12px; font-size: 13px; }
.tm-spieler-tipps__kopf { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
.tm-spieler-tipps__zeile { display: grid; grid-template-columns: 1fr auto auto; gap: 8px; padding: 3px 0; }
.tm-spieler-tipps .ok { color: #15803d; }

.tm-spieler-hinweis {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0 10px 8px;
  padding: 8px 10px 8px 12px;
  border-radius: 10px;
  background: #eef4fb;
  border: 1px solid #d3e2f3;
  font-size: 13px;
  color: #334155;
}

.tm-spieler-hinweis strong {
  font-weight: 700;
  color: #1e3a5f;
}

.tm-spieler-hinweis button {
  flex: none;
  appearance: none;
  border: 0;
  border-radius: 999px;
  padding: 5px 12px;
  font: inherit;
  font-weight: 600;
  line-height: 1.2;
  color: #fff;
  background: #5b7a99;
  cursor: pointer;
  transition: background .15s, transform .05s;
}

.tm-spieler-hinweis button:hover {
  background: #4a6684;
}

.tm-spieler-hinweis button:active {
  transform: scale(.97);
}

.tm-spieler-hinweis button:focus-visible {
  outline: 2px solid #5b7a99;
  outline-offset: 2px;
}

.tm-spark { color: #9ca3af; flex: none; width: 36px; height: 14px; }
.tm-spark--auf { color: #1d9e75; }
.tm-spark--ab { color: #d64545; }
.tm-spark--platzhalter { display: inline-block; }

.tm-tipp__braucht { font-size: 12px; line-height: 1.3; opacity: .75; margin-top:3px; }

.tm-sz { margin-top: 8px; }
.tm-sz__text { margin: 0 0 8px; font-size: 14px; line-height: 1.35; }
.tm-sz__chips { display: flex; flex-wrap: wrap; gap: 6px; }
.tm-sz__chip { padding: 6px 10px; border-radius: 10px; font-size: 13px; font-weight: 600; background: #eef0f4; color: #3a4252; }
.tm-sz__chip--auf { background: #dff3e6; color: #1b6b3f; }
.tm-sz__chip--ab { background: #fbe0e0; color: #9a2b2b; }

.tm-top { display: flex; flex-direction: column; gap: 8px; margin: 0 0 12px; padding: 0px 10px; }
.tm-top__kopf { margin: 0; font-size: 14px; }
.tm-top__block { border-radius: 10px; padding: 8px 12px; }
.tm-top__block--auf { background: #dff3e6; color: #1b6b3f; }
.tm-top__block--ab { background: #fbe0e0; color: #9a2b2b; }
.tm-top__titel { margin: 0 0 4px; font-size: 12px; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; }
.tm-top__zeile { margin: 0; font-size: 14px; line-height: 1.4; }
.tm-top__pkt { opacity: .8; font-size: 13px; }

.tm-kopf { 
  background: #1d2530; color: #fff; border-radius: 10px; 
  padding: 7px 12px; font-size: 13px; margin: 0px 10px 8px;
  overflow: hidden;
}
.tm-grp { display: flex; justify-content: space-between; align-items: center; width: 100%; background: #e3e7ec; color: #2c3541; border: 0; border-radius: 10px; padding: 9px 12px; font-size: 13px; font-weight: 700; margin: 8px 0; cursor: pointer; }
.tm-grp__hint { font-weight: 400; font-size: 12px; color: #3b4654; }


.tm-ueb--fix { position: sticky; bottom: 0; z-index: 2; display: flex; align-items: center; gap: 8px; background: #f3f5f8; border-top: 1px solid #d9dde3; padding: 6px 0; margin: 0; }
.tm-ueb--fix .tm-ueb__titel { flex: none; margin: 0; }
.tm-ueb--fix .tm-ueb__chips { flex-wrap: nowrap; overflow-x: auto; -webkit-overflow-scrolling: touch; }
.tm-ueb--fix .tm-ueb__chip { flex: none; }
.tm-ueb { margin: 10px 10px 0px 10px; }
.tm-ueb__titel { margin: 0 0 6px; font-size: 12px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: #3b4654; }
.tm-ueb__chips { display: flex; flex-wrap: wrap; gap: 6px; }
.tm-ueb__chip { display: flex; flex-direction: column; align-items: center; min-width: 46px; padding: 3px 8px; border-radius: 8px; font-size: 12px; line-height: 1.2; border: 2px solid transparent; }
.tm-ueb__chip--ok { background: #1f6f4a; color: #fff; }
.tm-ueb__chip--falsch { background: #fff; color: #a3261f; border-color: #a3261f; }
.tm-ueb__chip--offen { background: #e3e7ec; color: #3b4654; }
.tm-ueb__legende { margin: 6px 0 0; font-size: 12px; color: #3b4654; }
.tm-tipps--kompakt .tm-sz__text,
.tm-tipps--kompakt .tm-tipp__braucht { display: none; }

/* läuft: nur umrandet, roter Punkt */
.tm-ueb__chip--live { background: #fff; position: relative; }
.tm-ueb__chip--live.tm-ueb__chip--ok { color: #1f6f4a; border-color: #1f6f4a; }
.tm-ueb__chip--live.tm-ueb__chip--falsch { color: #a3261f; border-color: #a3261f; }
.tm-ueb__chip--live::after { content: ''; position: absolute; top: 3px; right: 4px; width: 6px; height: 6px; border-radius: 50%; background: #d93025; }

/* beendet: voll gefärbt */
.tm-ueb__chip--fertig.tm-ueb__chip--ok { background: #1f6f4a; color: #fff; }
.tm-ueb__chip--fertig.tm-ueb__chip--falsch { background: #a3261f; color: #fff; border-color: #a3261f; }

.tm-prog { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; margin: 0px 10px 8px; }
.tm-prog__box { display: flex; flex-direction: column; line-height: 1.25; padding: 6px 9px; border-radius: 10px; min-width: 0; }
.tm-prog__box--auf { background: #dff1e2; color: #256b3a; }
.tm-prog__box--ab { background: #fbdcdc; color: #a12b2b; }
.tm-prog__box:only-of-type { grid-column: 1 / -1; }
.tm-prog__best { grid-column: 1 / -1; margin: 0; padding: 0 4px; font-size: 12px; font-weight: 700; color: #256b3a; }
.tm-prog__l1 { font-weight: 700; font-size: 13px; }
.tm-prog__l2 { font-size: 12px; }
.tm-prog i, .tm-sz__chip i { font-style: normal; margin-right: 4px; }

.tm-sz__chips { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }
.tm-sz__chip { display: flex; flex-direction: column; line-height: 1.25; padding: 5px 8px; min-width: 0; }
.tm-sz__chip::before { content: none; }
.tm-sz__l1 { font-weight: 700; font-size: 13px; }
.tm-sz__l1, .tm-prog__l1 { display: flex; min-width: 0; white-space: nowrap; }
.tm-sz__n, .tm-prog__n { min-width: 0; overflow: hidden; text-overflow: ellipsis; }
.tm-sz__b, .tm-prog__b { flex: none; margin-right: 4px; font-size: 12px; }
.tm-sz__l2 { font-size: 12px; }


/* Variante C: Tipp-Pille und Szenario-Badge in der Teamzeile */
.tm-tipp__team { min-height: 28px; gap: 7px; }
.tm-pill { flex: none; width: 28px; text-align: center; font-size: 12px; font-weight: 800; border-radius: 999px; padding: 2px 0px; background: #e1e5ea; color: #4a5568; }
.tm-pill--ok { background: #1d9e75; color: #fff; }
.tm-pill--x { background: #d64545; color: #fff; }
.tm-sb { flex: none; font-size: 12px; font-weight: 700; 
  border-radius: 8px; padding: 3px 4px; line-height: 1.2; text-align: center; 
  background: #eef0f4; color: #4a5568; width: 82px; border:1px solid rgb(224, 224, 224); }
.tm-sb small { display: block; font-weight: 600; font-size: 11px; }
.tm-sb--auf { background: #dff3e6; color: #1b6b3f; }
.tm-sb--ab { background: #fbe0e0; color: #9a2b2b; }

/* Scrollleiste der Überblicksleiste ausblenden (verschiebbar bleibt sie) */
.tm-ueb--fix .tm-ueb__chips { scrollbar-width: none; }
.tm-ueb--fix .tm-ueb__chips::-webkit-scrollbar { display: none; }

</style>